import React from "react";

import LayoutBase from "commons/components/layout/LayoutBase";

import { SitemapType } from "commons/types/sitemap";

import DisplayApiError from "components/DisplayApiError";

import { useConfigContext } from "context/config";
import { useUserContext } from "context/user";

type PropsType = {
    readonly sitemap: SitemapType;
};

function PlatformLayout({ sitemap }: PropsType) {
    const user = useUserContext();
    const config = useConfigContext();

    const userAuthorities = React.useMemo(() => user.authorities, [user.authorities]);

    return (
        <LayoutBase
            sitemap={sitemap}
            userAuthorities={userAuthorities}
            accountLogout={<></>}
            logo={config.logoUrl ? `${process.env.PUBLIC_URL}${config.logoUrl}` : undefined}
            altLogo={config.backofficeName}
            logoDescription={config.logoUrl ? undefined : <span style={{ whiteSpace: "nowrap" }}>{config.backofficeName}</span>}
            environment={config.environment}
            environmentDescription={"ATTENZIONE! Stai operando in ambiente di test."}
            DisplayApiError={DisplayApiError}
            menuVersion={"v2"}
        />
    );
}

export default PlatformLayout;
